import { examAndGrade, semester } from "../client";

export const uploadExamMarks = (params) => {
  const user = {
    flag: "uploadExamMarks",
    parameters: {
      uploadExamMarks: params,
    },
  };
  return examAndGrade.post("/student/marks/upload", user);
};

export const downloadMarksTemplate = (params) => {
  const user = {
    flag: "downloadMarksTemplate",
    parameters: {
      examMarksTemplate: params,
    },
  };
  return examAndGrade.post("/student/marks/template/download", user);
};

export const getStudentSubjectMarks = (params) => {
  const user = {
    flag: "getStudentSubjectMarks",
    parameters: {
      studentNamesWithId: params,
    },
  };
  return semester.post("/get/semester/marks", user);
};

export const getStudentDetails = (params) => {
  const user = {
    flag: "getStudentDetails",
    parameters: {
      updateStudentMarks: params,
    },
  };
  return semester.post("/get/student/details", user);
};
 
export const UpdateSubjectMarks = (params) => {
  const user = {
    flag: "UpdateSubjectMarks",
    parameters: {
      updateStudentMarks: params,
    },
  };
  return semester.post("/update/subject/marks", user);
};
